import { render, staticRenderFns } from "./dashboardTeamsEventUnit.vue?vue&type=template&id=9d5c35d0&scoped=true&"
import script from "./dashboardTeamsEventUnit.vue?vue&type=script&lang=js&"
export * from "./dashboardTeamsEventUnit.vue?vue&type=script&lang=js&"
import style0 from "./dashboardTeamsEventUnit.vue?vue&type=style&index=0&id=9d5c35d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5c35d0",
  null
  
)

export default component.exports